import React from 'react'

export class Endereco extends React.Component {
  render () {
    const selecionado = this.props.enderecoSelecionado === this.props.endereco;
    return (
      <div className={`vx-enc-address-card${selecionado ? ' vx-enc-address-card--selected' : ''}`}
        onClick={() => this.props.selecionarEndereco(this.props.endereco)}>
        {selecionado && (
          <div className="vx-enc-address-selected-badge">
            <i className="material-icons">check_circle</i>
            Selecionado
          </div>
        )}
        <div className="vx-enc-address-street">
          {`${this.props.endereco.logradouro}, ${this.props.endereco.numero ? this.props.endereco.numero : 'S/N'}${this.props.endereco.complemento ? `, ${this.props.endereco.complemento}` : ''}`}
        </div>
        <div className="vx-enc-address-city">
          {`${this.props.endereco.bairro} - ${this.props.endereco.localidade} - ${this.props.endereco.uf}`}
        </div>
        <div className="vx-enc-address-cep">CEP: {this.props.endereco.cep}</div>
      </div>
    )
  }
}

export default Endereco
